import { IconProps } from 'blaze-ui/icons/Types'
import { forwardRef } from 'react'

export const LinkedIn = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Brand-logos">
        <rect width="20" height="20" rx="5" fill="#1275B1" />
        <g id="Vector">
          <path d="M4.47475 15.5031H6.84936V6.79622H4.47475V15.5031Z" fill="white" />
          <path
            d="M4.27686 4.39627C4.27686 5.16723 4.89743 5.79255 5.66205 5.79255C6.42747 5.79255 7.04725 5.16723 7.04725 4.39627C7.04725 3.62532 6.42668 3 5.66205 3C4.89743 3 4.27686 3.62532 4.27686 4.39627Z"
            fill="white"
          />
          <path
            d="M13.9732 15.5031H16.3478V10.1531C16.3478 5.99518 11.912 6.14636 10.8071 8.19328V6.79622H8.43244V15.5031H10.8071V11.0674C10.8071 8.6033 13.9732 8.40145 13.9732 11.0674V15.5031Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  )
})

export default LinkedIn
